import React, { useContext } from 'react';
import { Select, Tooltip, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RegisterFormTooltipContext } from 'src/context/RegisterFormTooltipContext';
import { getRegisterFormTooltipByKey } from 'src/constants/registerFormTooltips';

const StyledSelect = styled((props) => <Select {...props} />)();

const CustomSelect = ({ tooltip, tooltipKey, ...props }) => {
  const { enabled, defaultTooltip } = useContext(RegisterFormTooltipContext);
  const resolvedTooltip =
    tooltip || (tooltipKey ? getRegisterFormTooltipByKey(tooltipKey) : '');
  const tooltipText = resolvedTooltip || (enabled ? defaultTooltip : '');
  const select = <StyledSelect {...props} />;

  if (!tooltipText) {
    return select;
  }

  return (
    <Tooltip title={tooltipText}>
      <Box sx={{ width: '100%' }}>
        {select}
      </Box>
    </Tooltip>
  );
};

export default CustomSelect;
